import React from 'react';
import { LayoutPropType } from 'src/modules/parkplusStoreV2/types/layout';
import s from './CategoryCoverListing.module.scss';
import { useRouter } from 'next/router';
import ShimmerImage from 'core-lib/components/ShimmerImage';

const CategoryCoverListing = ({ data }: LayoutPropType) => {
  const router = useRouter();

  return (
    <div
      className={s.root}
      onClick={() => {
        const videoUrl = data?.metaData?.videoUrl;
        if (videoUrl) {
          router.push(videoUrl);
        }
      }}
    >
      {!!data && (
        <ShimmerImage
          className={s.shimmerBox}
          src={data?.backgroundImage}
          alt="backgroundImage"
          customStyle={{
            minHeight: '160px',
          }}
        />
      )}
    </div>
  );
};

export default CategoryCoverListing;
